import { c as _c } from "react/compiler-runtime";
import React, { FC, JSX, useRef, useState } from 'react';
import { useOnClickOutside } from 'react-recipes';
import { LFButton, LFButtonType } from './LFButton';
export const MenuFlyout: FC<{
  menu?: string;
  customMenu?: JSX.Element;
  icon?: JSX.Element | string;
  customStyles?: {
    button?: string;
    top?: string;
    bottom?: string;
    padding?: string;
  };
  onOverflowMenuClick?: () => void;
  openConfirmModal?: () => void;
  menuTestId?: string;
  menuButtonTestId?: string;
}> = t0 => {
  const $ = _c(20);
  const {
    menu,
    customMenu,
    icon: t1,
    customStyles,
    onOverflowMenuClick,
    openConfirmModal,
    menuTestId,
    menuButtonTestId
  } = t0;
  const icon = t1 === undefined ? "\u2022\u2022\u2022" : t1;
  const dropdownRef = useRef(null);
  const [toggleDropdown, setToggleDropdown] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setToggleDropdown(false);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  useOnClickOutside(dropdownRef, t2);
  const t3 = `${customStyles?.padding ? customStyles.padding : "px-2 py-1"}`;
  const t4 = customStyles?.button ? customStyles.button : "\n              mb-2 bg-smoke tracking-widest text-black shadow-xs\n              hover:shadow-md\n            ";
  let t5;
  if ($[1] !== onOverflowMenuClick) {
    t5 = e => {
      e.stopPropagation();
      setToggleDropdown(_temp);
      if (onOverflowMenuClick) {
        onOverflowMenuClick();
      }
    };
    $[1] = onOverflowMenuClick;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== icon || $[4] !== menuButtonTestId || $[5] !== t3 || $[6] !== t4 || $[7] !== t5) {
    t6 = <LFButton testId={menuButtonTestId} type={LFButtonType.PLAIN} padding={t3} className={t4} onClick={t5}>{icon}</LFButton>;
    $[3] = icon;
    $[4] = menuButtonTestId;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== customMenu || $[10] !== customStyles?.bottom || $[11] !== customStyles?.top || $[12] !== menu || $[13] !== menuTestId || $[14] !== openConfirmModal || $[15] !== toggleDropdown) {
    t7 = toggleDropdown && <div className={`
            absolute border-silver
            ${customStyles?.top || "top-12"}
            ${customStyles?.bottom || "bottom-0"}
            lg:94
            right-0 z-5 h-fit w-90 rounded-md border bg-white p-2 shadow
          `} aria-labelledby="modal-dropdown" role="dialog" aria-modal="true" data-testid={menuTestId}>{customMenu ? customMenu : <button onClick={e_0 => {
        e_0.stopPropagation();
        if (openConfirmModal) {
          openConfirmModal();
        }
      }}><p className="text-negative-300' w-max px-2 font-normal">{menu}</p></button>}</div>;
    $[9] = customMenu;
    $[10] = customStyles?.bottom;
    $[11] = customStyles?.top;
    $[12] = menu;
    $[13] = menuTestId;
    $[14] = openConfirmModal;
    $[15] = toggleDropdown;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <div className={"\n        relative flex w-fit justify-end\n        lg:items-center lg:justify-center\n      "} ref={dropdownRef}>{t6}{t7}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};
function _temp(prev) {
  return !prev;
}